<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> CEST </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-toolbar-title v-if="cest.id"
          >{{ cest.id }} -
          {{ cest.name.substring(0, 30).toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                v-model="cest.code"
                class="text-field-uppercase"
                label="Código"
                v-mask="'99.999.99'"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="10"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="6">
              <v-textarea
                name="input-7-1"
                label="Descrição"
                class="text-field-uppercase"
                auto-grow
                dense
                outlined
                :value="cest.name"
                @input="(value) => (cest.name = value)"
              ></v-textarea>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/requests/CestRequest";

import AwesomeMask from "awesome-mask";

export default {
  components: {},
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    loading: false,
    cest: {
      id: "",
      code: "",
      name: "",
    },
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getCest(this.$route.params.id);
      }
    },
    async getCest(id) {
      // this.showLoading();
      this.loading = true;
      try {
        this.cest = await API.getById(id);
      } catch (error) {
        this.cest = {};
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    goToBackList() {
      this.$router.push({ name: "Cest" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.cest.name = this.cest.name.toUpperCase();
        let data = { ...this.cest };
        // let data = new URLSearchParams(this.cest);
        if (this.cest.id === "") {
          this.post(data);
        } else {
          this.update(this.cest.id, data);
        }
      }
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      try {
        await API.post(data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        await API.update(id, data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
  },
};
</script>
<style>
.text-field-uppercase input,
.text-field-uppercase textarea {
  text-transform: uppercase;
}
</style>
